/* eslint-disable react-hooks/exhaustive-deps */
import * as Icon from 'base/ui/components/Icons';

import { Form, Input, InputNumber, Spin } from 'antd';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { functionPresenter, functionStore, userStore } from 'stores/root_store';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import BoxContainer from 'base/ui/components/BoxContainer';
import CustomBreadcrumb from 'base/ui/components/CustomBreadcrumb';
import CustomButton from 'base/ui/components/Button';
import { SYSTEM_TITLE } from 'utils/constants';
import { observer } from 'mobx-react';
import { removeEmptyValues } from 'utils/transformHelper';
import { usePermission } from 'hooks/usePermission';
import { useTranslation } from 'react-i18next';

export const createAddUpdateFunction = () => {
    return observer(() => {
        // translate en/vn
        const { t } = useTranslation();
        // Get data params from url
        const { id: idParams } = useParams();
        // Check id để đặt tên trang
        let pageTitle = '';

        // Nếu có id là chỉnh sửa (xem chi tiết)
        if (idParams) {
            // Kiểm tra phân quyền
            usePermission('INDEX'); // Kiểm tra xem được quyền truy cập vào trang
            pageTitle = t('page-title.update');
            document.title = pageTitle + ' - ' + SYSTEM_TITLE;
        } else {
            // Kiểm tra phân quyền
            usePermission('CREATE');
            pageTitle = t('page-title.create');
            document.title = pageTitle + ' - ' + SYSTEM_TITLE;
        }

        const navigate = useNavigate();
        // Check button save and save continue
        let isSaveAndContinue = false;

        const [form] = Form.useForm();
        // Loading
        const [loading, setLoading] = useState(false);

        //=================================================FUNCTION===========================================================//
        //=================================================FUNCTION===========================================================//
        // Call api detail store
        const getDetailPage = async () => {
            setLoading(true);
            await functionPresenter.getFunctionById(functionStore, idParams || '');
            if (functionStore.functionDetail.isSuccess) {
                form.setFieldsValue(functionStore.functionDetail.data);
                setLoading(false);
            } else {
                navigate('/Permission/Function');
            }
        };

        // Handle create / update 
        const onFinish = async (values: any) => {
            setLoading(true);
            removeEmptyValues(values);
            if (!idParams) {
                // create 
                const result = await functionPresenter.createFunction(values);
                if (result) {
                    // Redirect to search page routing (Button Save)
                    if (!isSaveAndContinue) {
                        navigate('/Permission/Function');
                    }
                    form.resetFields();
                }
            } else {
                // update 
                const result = await functionPresenter.updateFunction({
                    ...values,
                });
                if (result) {
                    // Redirect to search page routing (Button Save)
                    if (!isSaveAndContinue) {
                        navigate('/Permission/Function');
                    }
                }
            }
            setLoading(false);
        };



        useEffect(() => {
            if (idParams) {
                getDetailPage()
            }
        }, []);

        // giá trị ban đầu của form
        const initialValues = {
            actived: true,
        };
        function ButtonCreateUpdate() {
            return (
                <>
                    <CustomButton
                        icon={<Icon.Download className="!fill-[#262626]" />}
                        htmlType="submit"
                        disabled={loading}
                        loading={loading}
                        onClick={() => {
                            isSaveAndContinue = false;
                            form.submit();
                        }}
                    >
                        {t('btn.save')}
                    </CustomButton>
                    <CustomButton
                        type="primary"
                        icon={<Icon.Download />}
                        disabled={loading}
                        loading={loading}
                        onClick={() => {
                            isSaveAndContinue = true;
                            form.submit();
                        }}
                    >
                        {idParams ? t('btn.save-update') : t('btn.save-continue-create')}
                    </CustomButton>
                </>
            );
        }
        return (
            <>
                <div className="flex flex-col h-full">
                    <CustomBreadcrumb
                        pagetitle={[
                            {
                                title: "Thao tác",
                                link: '/Permission/Function',
                            },
                            {
                                title: pageTitle,
                                link: idParams ? `/Permission/Function/${idParams}` : '/Permission/Function/create',
                            },
                        ]}
                        extra={
                            <>
                                <div className="custom__mobile--save flex space-x-2">
                                    {!idParams && userStore.userPermission?.includes('CREATE') ? <ButtonCreateUpdate /> : null}
                                    {idParams && userStore.userPermission?.includes('EDIT') ? <ButtonCreateUpdate /> : null}
                                </div>
                            </>
                        }
                    />
                    {/* Form nhập  */}
                    <BoxContainer fullHeight>
                        <Spin spinning={loading}>
                            <SearchForm
                                onFinish={onFinish}
                                initialValues={idParams ? {} : initialValues}
                                form={form}
                                layout='horizontal'
                                wrapperCol={{ span: 16 }}
                                labelCol={{ span: 6 }}
                                column='col-1'
                                colon={false}
                            >
                                {/* Mã thao tác */}
                                <SearchItem
                                    rules={[{ required: true, message: 'Hãy nhập thông tin cho trường "Mã thao tác"' }]}
                                    name={'functionId'}
                                    label={"Mã thao tác"}
                                >
                                    <Input disabled={idParams ? true : false} />
                                </SearchItem>
                                <SearchItem
                                    rules={[{ required: true, message: 'Hãy nhập thông tin cho trường "Tên thao tác"' }]}
                                    name={'functionName'}
                                    label={"Tên thao tác"}
                                >
                                    <Input />
                                </SearchItem>

                                {/* thứ tự hiển thị */}
                                <SearchItem
                                    name={'orderIndex'}
                                    label={'Thứ tự'}
                                >
                                    <InputNumber className="!w-full" controls={false} />
                                </SearchItem>


                            </SearchForm>
                        </Spin>
                    </BoxContainer>
                </div>
            </>
        );
    });
};

